import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import Nav from './Nav';
import '../assets/css/psearch.css';

function PaymentCancelled() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  useEffect(() => {
    const getUser = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      setUser(user);
    };
    getUser();
  }, []);

  return (
    <div className="payment-result-page">
      <Nav user={user} />
      <div className="payment-result-container">
        <div className="payment-status cancelled">
          <div className="cancelled-icon">↩</div>
          <h2>Payment Cancelled</h2>
          <p>Your payment was cancelled. No charges were made.</p>
          <p className="subtext">You can try again anytime when you're ready to unlock more try-ons.</p>
          <button 
            className="continue-btn"
            onClick={() => navigate('/')}
          >
            Return to exploring
          </button>
        </div>
      </div>
    </div>
  );
}

export default PaymentCancelled;
